import { createRouter, createWebHistory } from "vue-router";
import authentication from "@/services/authentication";
import baseMenu from "@/components/navigation/menu";
import utility from "@/services/utility";
import { useRootStore } from "@/stores/root";
import { useNavigationStore } from "@/stores/navigation";
import { useCustomersStore } from "@/stores/customers";
import { useProductsStore } from "@/stores/products";
const Login = () => import("@/views/login/Login.vue");
const LoginAccess = () => import("@/views/login/partials/LoginAccess.vue");
const LoginPasswordExpired = () => import("@/views/login/partials/LoginPasswordExpired.vue");
const LoginRecoverPassword = () => import("@/views/login/partials/LoginRecoverPassword.vue");
const LoginForgottenPassword = () => import("@/views/login/partials/LoginForgottenPassword.vue");
const LoginCreatePassword = () => import("@/views/login/partials/LoginCreatePassword.vue");
const LoginSocietySelection = () => import("@/views/login/partials/LoginSocietySelection.vue");
const Unregistered = () => import("@/views/login/Unregistered.vue");
import PostLoginLayout from "@/components/layout/PostLoginLayout.vue";
const Dashboard = () => import("@/views/dashboard/Dashboard.vue");
const DashboardIndex = () => import("@/views/dashboard/DashboardIndex.vue");
const DailyDocuments = () => import("@/views/dashboard/DailyDocuments.vue");
const BackorderDocuments = () => import("@/views/dashboard/BackorderDocuments.vue");
const BackorderDocumentsRows = () => import("@/views/dashboard/BackorderDocumentsRows.vue");
const RetiredDocuments = () => import("@/views/dashboard/RetiredDocuments.vue");
const OffersSolicit = () => import("@/views/dashboard/OffersSolicit.vue");
const Revenue = () => import("@/views/revenue/Revenue.vue");
const Commissions = () => import("@/views/commissions/Commissions.vue");
const Customers = () => import("@/views/customers/Customers.vue");
const CustomersList = () => import("@/views/customers/list/CustomersList.vue");
const CustomerDetail = () => import("@/views/customers/detail/CustomerDetail.vue");
const CustomerCard = () => import("@/views/customers/detail/tabs/CustomerCard.vue");
const CustomerContacts = () => import("@/views/customers/detail/tabs/CustomerContacts.vue");
const CustomerDocuments = () => import("@/views/customers/detail/tabs/CustomerDocuments.vue");
const CustomerConsignmentPayment = () => import("@/views/customers/detail/tabs/CustomerConsignmentPayment.vue");
const CustomerOffers = () => import("@/views/customers/detail/tabs/CustomerOffers.vue");
const CustomerOrders = () => import("@/views/customers/detail/tabs/CustomerOrders.vue");
const CustomerBonus = () => import("@/views/customers/detail/tabs/CustomerBonus.vue");
const CustomerDiscounts = () => import("@/views/customers/detail/tabs/CustomerDiscounts.vue");
const CustomerTicketsCashed = () => import("@/views/customers/detail/tabs/CustomerTicketsCashed.vue");
const CustomerSales = () => import("@/views/customers/detail/tabs/CustomerSales.vue");
const CustomerRelations = () => import("@/views/customers/detail/tabs/CustomerRelations.vue");
const CustomerSurvey = () => import("@/views/customers/detail/tabs/CustomerSurvey.vue");
const CustomerDocumentary = () => import("@/views/customers/detail/tabs/CustomerDocumentary.vue");
const CustomerDestinations = () => import("@/views/customers/detail/tabs/CustomerDestinations.vue");
const BillsTab = () => import("@/views/customers/detail/tabs/expirations/BillsTab.vue");
const ExpirationsTab = () => import("@/views/customers/detail/tabs/expirations/ExpirationsTab.vue");
const ReceiptsTab = () => import("@/views/customers/detail/tabs/expirations/ReceiptsTab.vue");
const CustomerExpirations = () => import("@/views/customers/detail/tabs/CustomerExpirations.vue");
const Products = () => import("@/views/products/Products.vue");
const ProductsList = () => import("@/views/products/list/ProductsList.vue");
const LastProductsTab = () => import("@/views/products/list/LastProductsTab.vue");
const SalesProductsTab = () => import("@/views/products/list/SalesProductsTab.vue");
const ProductDetail = () => import("@/views/products/detail/ProductDetail.vue");
const ProductCard = () => import("@/views/products/detail/tabs/ProductCard.vue");
const ProductArrivals = () => import("@/views/products/detail/tabs/ProductArrivals.vue");
const ProductCommitments = () => import("@/views/products/detail/tabs/ProductCommitments.vue");
const ProductHistory = () => import("@/views/products/detail/tabs/ProductHistory.vue");
const ProductAgencies = () => import("@/views/products/detail/tabs/ProductAgencies.vue");
const ProductAvailabilities = () => import("@/views/products/detail/tabs/ProductAvailabilities.vue");
const ProductCrossReferences = () => import("@/views/products/detail/tabs/ProductCrossReferences.vue");
const UnsolvedDocuments = () => import("@/views/dashboard/UnsolvedDocuments.vue");
const ExpiredDocuments = () => import("@/views/dashboard/ExpiredDocuments.vue");
const CustomersRisk = () => import("@/views/dashboard/CustomersRisk.vue");
const CustomersRiskDetail = () => import("@/views/dashboard/CustomersRiskDetail.vue");
const ReceiptsNotReceived = () => import("@/views/dashboard/ReceiptsNotReceived.vue");
const DocumentDetail = () => import("@/views/documents/DocumentDetail.vue");
const Offers = () => import("@/views/offers/Offers.vue");
const Orders = () => import("@/views/orders/Orders.vue");
const Bills = () => import("@/views/bills/Bills.vue");
const InsertedDocuments = () => import("@/views/documents/InsertedDocuments.vue");
const DocumentAnalysis = () => import("@/views/documents/DocumentAnalysis.vue");
const OfferDetail = () => import("@/views/offers/detail/OfferDetail.vue");
const Cart = () => import("@/views/documents/cart/Cart.vue");
const Statistics = () => import("@/views/stats/Statistics.vue");
const StatisticsTemplates = () => import("@/views/stats/StatisticsTemplates.vue");
const StatisticsDetail = () => import("@/views/stats/StatisticsDetail.vue");
const StatisticsMixDetail = () => import("@/views/stats/StatisticsMixDetail.vue");
const Activities = () => import("@/views/activities/Activities.vue");
const RecommendedActivities = () => import("@/views/activities/RecommendedActivities.vue");
const Tags = () => import("@/views/tags/Tags.vue");
const TagsManagement = () => import("@/views/tags/TagsManagement.vue");
const Tasks = () => import("@/views/tasks/Tasks.vue");
const OpenedTasks = () => import("@/views/tasks/OpenedTasks.vue");
const SharedTasks = () => import("@/views/tasks/SharedTasks.vue");
const Calendar = () => import("@/views/calendar/Calendar.vue");
const CalendarEvents = () => import("@/views/calendar/CalendarEvents.vue");
const ProductReplacer = () => import("@/views/products/detail/tabs/ProductReplacer.vue");
const CustomersNew = () => import("@/views/dashboard/CustomersNew.vue");
const PendingDocuments = () => import("@/views/dashboard/PendingDocuments.vue");
import DocumentMargins from "@/components/documents/DocumentMargins.vue";
const DeliveryDashboard = () => import("@/views/delivering/DeliveryDashboard.vue");
const SignedDocDashboard = () => import("@/views/signedDocuments/SignedDocDashboard.vue");
const SignedCourierDashboard = () => import("@/views/signedForCourier/SignedCourierDashboard.vue");

export function setNavigationTitle(to) {
  let navTitle = "Nessun cliente selezionato";
  let navLink = false;
  if (useRootStore().lastCustomer.anacod != "") {
    navTitle = `${useRootStore().lastCustomer.anacod} - ${useRootStore().lastCustomer.ragsoc}`;
    navLink = true;
  }
  to.matched.forEach((route) => {
    if (route.meta.hasCustomNavTitle) {
      useRootStore().setNavigationTitle(navTitle);
      useRootStore().setHasNavigationTitleLink(navLink);
    }
  });
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      redirect: "/login/access",
      beforeEnter: (to, from, next) => {

        if (useRootStore().user && !useRootStore().loggingOut) {
          // TODO: WILLY: sostituire con flag per delivery
          // const deliv = useRootStore().user?.profile.delivery_flg &&
          // useRootStore().user?.profile.delivery_flg === 'S';
          // if (deliv) {
          //   next('/delivery');
          // } else {
          //   next('/dashboard');
          // }
          
          const application = useRootStore().user?.profile.delivery_flg;
          
          switch (application) {
            case "S":
              next("/delivery");
              break;
            case "F":
              next("/signDoc");
              break;
            case "C":
              next("/signCourier");
              break;
            default:
              next("/dashboard");
              break;
          }
        } else {
          // this is called to empty the cache
          authentication.logout();
          next();
        }
      },
      children: [
        {
          path: "access",
          name: "LoginAccess",
          component: LoginAccess,
        },
        {
          path: "create-password",
          name: "LoginCreatePassword",
          component: LoginCreatePassword,
          beforeEnter: (to, from, next) => {
            if (
              !useRootStore().user ||
              useRootStore().user.status !== "firstAccess"
            )
              next("/login");
            else next();
          },
        },
        {
          path: "select-society",
          name: "LoginSocietySelection",
          component: LoginSocietySelection,
          beforeEnter: (to, from, next) => {
            if (
              !useRootStore().user ||
              useRootStore().user.status !== "multiSocieta"
            )
              next("/login");
            else next();
          },
        },
        {
          path: "renew-password",
          name: "LoginRenewPassword",
          component: LoginCreatePassword,
          beforeEnter: (to, from, next) => {
            if (
              !useRootStore().user ||
              useRootStore().user.status !== "expiredPassword"
            )
              next("/login");
            else next();
          },
        },
        {
          path: "password-expired",
          name: "LoginPasswordExpired",
          component: LoginPasswordExpired,
          beforeEnter: (to, from, next) => {
            if (
              !useRootStore().user ||
              useRootStore().user.status !== "expiredPassword"
            )
              next("/login");
            else next();
          },
        },
        {
          path: "forgotten-password",
          name: "LoginForgottenPassword",
          component: LoginForgottenPassword,
        },
        {
          path: "recover-password",
          name: "LoginRecoverPassword",
          component: LoginRecoverPassword,
        },
        {
          path: "reset-password",
          name: "LoginResetPassword",
          component: LoginCreatePassword,
          props: (route) => ({
            userId: route.query.idsession_txt,
            token: route.query.token,
            resetPassword: true,
          }),
        },
      ],
    },
    {
      path: "/unregistered",
      name: "Unregistered",
      component: Unregistered,
    },
    {
      path: "/delivery",
      name: "Delivery",
      component: DeliveryDashboard,
      beforeEnter: async (to, from, next) => {
        try {
          const user = await authentication.checkAuth();
          useRootStore().setUser(user);
          if (!user) {
            next("/login");
            return;
          }
          next();
        } catch (err) {
          useRootStore().setUser(null);
          next("/login");
        }
      },
    },
    {
      path: "/signDoc",
      name: "SignedDocuments",
      component: SignedDocDashboard,
      beforeEnter: async (to, from, next) => {
        try {
          const user = await authentication.checkAuth();
          useRootStore().setUser(user);
          if (!user) {
            next("/login");
            return;
          }
          next();
        } catch (err) {
          useRootStore().setUser(null);
          next("/login");
        }
      },
    },
    {
      path: "/signCourier",
      name: "SignedCourier",
      component: SignedCourierDashboard,
      beforeEnter: async (to, from, next) => {
        try {
          const user = await authentication.checkAuth();
          useRootStore().setUser(user);
          if (!user) {
            next("/login");
            return;
          }
          next();
        } catch (err) {
          useRootStore().setUser(null);
          next("/login");
        }
      },
    },
    {
      path: "/",
      name: "Home",
      component: PostLoginLayout,
      redirect: () => {
        const user = useRootStore().user;
        if (!user) return "/login";
        // TODO: WILLY: sostituire con flag per delivery
        // const deliv =
        //   user?.profile.delivery_flg && user?.profile.delivery_flg === "S";
        // if (deliv) {
        //   return "/delivery";
        // }
        const application = useRootStore().user?.profile.delivery_flg;
        switch (application) {
          case "S":
            return "/delivery";
          case "F":
          return "/signDoc";
            case "C":
              return "/signCourier";
          default:
            return "/dashboard";
        }
      },
      beforeEnter: async (to, from, next) => {
        try {
          const user = await authentication.checkAuth();
          useRootStore().setUser(user);
          if (!user) {
            next("/login");
            return;
          }
          // Ogni redirect DEVE uscire con `return`: senza, l'esecuzione proseguiva
          // fino al `next()` finale → next() chiamato due volte (Vue Router error) e
          // l'utente di un'app (delivery/courier/firma) finiva comunque su /dashboard,
          // violando l'isolamento tra applicazioni e scatenando 401 → autologout.
          // flag per delivery
          const deliv =
            user?.profile.delivery_flg && user?.profile.delivery_flg === "S";
          if (deliv) {
            next("/delivery");
            return;
          }
          // flag per courrier
          const courrier =
            user?.profile.delivery_flg && user?.profile.delivery_flg === "C";
          if (courrier) {
            next("/signCourier");
            return;
          }

          // flag per firma
          const firma =
            user?.profile.delivery_flg && user?.profile.delivery_flg === "F";
          if (firma) {
            next("/signDoc");
            return;
          }
          const sideMenu = useRootStore().sideMenu;
          if (!sideMenu || !sideMenu.length)
            await useNavigationStore().fetchSideMenu({ forceRefresh: true });
          next();
        } catch (err) {
          useRootStore().setUser(null);
          next("/login");
        }
      },
      children: [
        {
          path: "/dashboard",
          name: "Dashboard",
          redirect: "/dashboard/index",
          component: Dashboard,
          beforeEnter: async (to, from, next) => {
            const user = useRootStore().user;
            const sideMenu = useRootStore().sideMenu;
            const [firstMenuItem] = sideMenu;
            const firstNavigable = sideMenu.find((i) => !!i.route);
            if (
              user?.profile.biflg === "S" &&
              from.path.includes("/login") &&
              firstNavigable?.route !== "Dashboard"
            ) {
              next({
                name: firstNavigable.route,
                params: firstNavigable.routeParams || {},
              });
              return;
            }
            if (
              user?.profile.biflg === "S" &&
              from.path.includes("/statistics") &&
              firstMenuItem.route !== "Dashboard"
            ) {
               
              to.meta.menuSection = sideMenu[0].name;
               
              to.params.type = sideMenu[0].routeParams.type;
              useRootStore().setSelectedNav(to.meta.menuSection);
              const menuItem = baseMenu.find(
                (item) => item.name === to.meta.menuSection
              );
              useRootStore().setSectionCode(menuItem.code);
              next({ name: firstMenuItem.route });
              return;
            }
            to.matched.forEach((route) => {
              if (route.meta.hasCustomNavTitle) {
                useRootStore().setNavigationTitle("");
              }
            });
            next();
          },
          meta: {
            menuSection: "dashboard",
          },
          children: [
            {
              path: "index",
              name: "DashboardIndex",
              component: DashboardIndex,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "backorder-documents",
              name: "BackorderDocuments",
              component: BackorderDocuments,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "backorder-documents/:documentId/analysis",
              name: "BackorderAnalysis",
              component: DocumentAnalysis,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "retired-documents",
              name: "RetiredDocuments",
              component: RetiredDocuments,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "backorder-rows",
              name: "BackorderDocumentsRows",
              component: BackorderDocumentsRows,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "backorder-documents/:documentId",
              name: "BackorderDocumentsDetail",
              component: DocumentDetail,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "daily-documents",
              name: "DailyDocuments",
              component: DailyDocuments,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "daily-documents/:documentId",
              name: "DailyDocumentsDetail",
              component: DocumentDetail,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "daily-documents/analysis/:documentId",
              name: "DocumentAnalysis",
              component: DocumentAnalysis,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "unsolved",
              name: "UnsolvedDocuments",
              component: UnsolvedDocuments,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "unsolved/:documentId",
              name: "UnsolvedDocumentDetail",
              component: DocumentDetail,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "expired",
              name: "ExpiredDocuments",
              component: ExpiredDocuments,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "expired/:documentId",
              name: "ExpiredDocumentDetail",
              component: DocumentDetail,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "customers-risk",
              name: "CustomersRisk",
              component: CustomersRisk,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "customers-new",
              name: "CustomersNew",
              component: CustomersNew,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "pending-documents",
              name: "PendingDocuments",
              component: PendingDocuments,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
                        {
              path: "pending/:documentId",
              name: "PendingDocumentDetail",
              component: DocumentDetail,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "receipts",
              name: "ReceiptsNotReceived",
              component: ReceiptsNotReceived,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "customers-risk/:customerCode",
              name: "CustomersRiskDetail",
              component: CustomersRiskDetail,
              meta: {
                menuSection: "dashboard",
                hasCustomNavTitle: true,
              },
            },

            {
              path: "offers-solicit",
              name: "OffersSolicit",
              component: OffersSolicit,
              meta: {
                menuSection: "dashboard",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "offers-solicit/:documentId/detail",
              name: "OffersSolicitDetail",
              component: DocumentDetail,
              meta: {
                menuSection: "dashboard",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "offers-solicit/:documentId",
              name: "OffersSolicitConfirm",
              component: OfferDetail,
              meta: {
                menuSection: "dashboard",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
          ],
        },
        {
          path: "/customers",
          name: "Customers",
          redirect: "/customers/list",
          component: Customers,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            setNavigationTitle(to);
            next();
          },
          meta: {
            menuSection: "customers",
            hidden: true,
          },
          children: [
            {
              path: "list",
              name: "CustomersList",
              component: CustomersList,
              meta: {
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                menuSection: "customers",
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":customerId",
              name: "CustomerDetail",
              // Vue Router 4 non interpola i parametri nelle redirect string: usiamo una
              // funzione così `:customerId` viene risolto (altrimenti la card riceve il
              // letterale ":customerId" e i tile non caricano).
              redirect: to => ({ name: "CustomerCard", params: { customerId: to.params.customerId } }),
              component: CustomerDetail,
              beforeEnter: async (to, from, next) => {
                const [customer] =
                  (await useCustomersStore().fetchCustomer({
                    customerId: to.params.customerId,
                  })) || [];
                const customerTitle =
                  customer && customer.ragsoc && customer.anacod
                    ? `${customer.anacod} - ${customer.ragsoc}`
                    : "";
                useRootStore().setDetail({
                  title: customerTitle,
                  back: "/customers/list",
                  ...customer,
                });
                next();
              },
              meta: {
                menuSection: "customers",
                detail: "customerName",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
              children: [
                {
                  path: "card",
                  name: "CustomerCard",
                  component: CustomerCard,
                  meta: {
                    tabs: {
                      customerDetail: "customerCard",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "documents",
                  name: "CustomerDocuments",
                  component: CustomerDocuments,
                  meta: {
                    tabs: {
                      customerDetail: "customerDocuments",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "consignmentPayment",
                  name: "CustomerConsignmentPayment",
                  component: CustomerConsignmentPayment,
                  meta: {
                    tabs: {
                      customerDetail: "CustomerConsignmentPayment",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },                
                {
                  path: "documents/:documentId",
                  name: "DocumentDetail",
                  component: DocumentDetail,
                  meta: {
                    hideActionsBar: true,
                    tabs: {
                      customerDetail: "customerDocuments",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "contacts",
                  name: "CustomerContacts",
                  component: CustomerContacts,
                  meta: {
                    tabs: {
                      customerDetail: "customerContacts",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "bonus",
                  name: "CustomerBonus",
                  component: CustomerBonus,
                  meta: {
                    tabs: {
                      customerDetail: "customerBonus",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "offers",
                  name: "CustomerOffers",
                  component: CustomerOffers,
                  meta: {
                    tabs: {
                      customerDetail: "customerOffers",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "offers/:documentId",
                  name: "OfferDetail",
                  component: DocumentDetail,
                  meta: {
                    tabs: {
                      customerDetail: "customerOffers",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "orders",
                  name: "CustomerOrders",
                  component: CustomerOrders,
                  meta: {
                    tabs: {
                      customerDetail: "customerOrders",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "orders/:documentId",
                  name: "OrderDetail",
                  component: DocumentDetail,
                  meta: {
                    hideActionsBar: true,
                    tabs: {
                      customerDetail: "customerOrders",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "discounts",
                  name: "CustomerDiscounts",
                  component: CustomerDiscounts,
                  meta: {
                    hideActionsBar: true,
                    tabs: {
                      customerDetail: "customerDiscounts",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDiscounts",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "tickets",
                  name: "CustomerTicketsCashed",
                  component: CustomerTicketsCashed,
                  meta: {
                    hideActionsBar: true,
                    tabs: {
                      customerDetail: "customerTicketsCashed",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerTicketsCashed",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "tickets/:documentId",
                  name: "TicketDetail",
                  component: DocumentDetail,
                  meta: {
                    hideActionsBar: true,
                    tabs: {
                      customerDetail: "customerOrders",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "expirations",
                  name: "CustomerExpirations",
                  component: CustomerExpirations,
                  redirect: () =>
                    /^\/customers\/(.*)\/expirations(.*)/g.test(
                      router.currentRoute.value.path
                    )
                      ? router.currentRoute.value.path
                      : "expirations/bills",
                  meta: {
                    tabs: {
                      customerDetail: "customerExpirations",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                  },
                  children: [
                    {
                      path: "bills",
                      name: "BillsTab",
                      component: BillsTab,
                      meta: {
                        tabs: {
                          customerDetail: "customerExpirations",
                          customerExpirations: "bills",
                        },
                        menuSection: "customers",
                        hasChangeCustomer: true,
                        navTitleRoute: "CustomerDetail",
                        hasCustomNavTitle: true,
                        hasCart: true,
                        showCart: () => !!useRootStore().lastCartPath,
                      },
                    },
                    {
                      path: "expirations",
                      name: "ExpirationsTab",
                      component: ExpirationsTab,
                      meta: {
                        tabs: {
                          customerDetail: "customerExpirations",
                          customerExpirations: "expirations",
                        },
                        menuSection: "customers",
                        hasChangeCustomer: true,
                        navTitleRoute: "CustomerDetail",
                        hasCustomNavTitle: true,
                        hasCart: true,
                        showCart: () => !!useRootStore().lastCartPath,
                      },
                    },
                    {
                      path: "receipts",
                      name: "ReceiptsTab",
                      component: ReceiptsTab,
                      meta: {
                        tabs: {
                          customerDetail: "customerExpirations",
                          customerExpirations: "receipts",
                        },
                        menuSection: "customers",
                        hasChangeCustomer: true,
                        navTitleRoute: "CustomerDetail",
                        hasCustomNavTitle: true,
                        hasCart: true,
                        showCart: () => !!useRootStore().lastCartPath,
                      },
                    },
                  ],
                },
                {
                  path: "sales",
                  name: "CustomerSales",
                  component: CustomerSales,
                  meta: {
                    tabs: {
                      customerDetail: "customerSales",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "sales/:documentId",
                  name: "SaleDetail",
                  component: DocumentDetail,
                  meta: {
                    hideActionsBar: true,
                    tabs: {
                      customerDetail: "customerSales",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "relations",
                  name: "CustomerRelations",
                  component: CustomerRelations,
                  meta: {
                    tabs: {
                      customerDetail: "customerRelations",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "survey",
                  name: "CustomerSurvey",
                  component: CustomerSurvey,
                  meta: {
                    tabs: {
                      customerDetail: "customerSurvey",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "documentary",
                  name: "CustomerDocumentary",
                  component: CustomerDocumentary,
                  meta: {
                    tabs: {
                      customerDetail: "customerDocumentary",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "destinations",
                  name: "CustomerDestinations",
                  component: CustomerDestinations,
                  meta: {
                    tabs: {
                      customerDetail: "customerDestinations",
                    },
                    menuSection: "customers",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/products",
          name: "Products",
          redirect: "/products/list",
          component: Products,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            if (to.params.productId) {
              const rows = await useProductsStore().fetchProductsList({
                searchText: to.params.productId,
              });
              const prod = (rows || []).find(
                (item) => item.codart === to.params.productId
              );
              if (prod) {
                useRootStore().setDetail({
                  payload: prod,
                  back: "/products/list",
                });
              }
            }
            setNavigationTitle(to);
            next();
          },
          meta: {
            menuSection: "products",
            hidden: true,
            index: "products",
          },
          children: [
            {
              path: "list",
              name: "ProductsList",
              component: ProductsList,
              redirect: () =>
                /^\/products\/list(.*)/g.test(router.currentRoute.value.path)
                  ? router.currentRoute.value.path
                  : "/products/list/last",
              meta: {
                menuSection: "products",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
              children: [
                {
                  path: "last",
                  name: "LastProductsTab",
                  component: LastProductsTab,
                  meta: {
                    tabs: {
                      productsList: "last",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () =>
                      (!!router.currentRoute.value.query.cart &&
                        !!router.currentRoute.value.query.fromSection) ||
                      !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "sales",
                  name: "SalesProductsTab",
                  component: SalesProductsTab,
                  meta: {
                    tabs: {
                      productsList: "sales",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () =>
                      !!router.currentRoute.value.query.cart ||
                      !!useRootStore().lastCartPath,
                  },
                },
              ],
            },
            {
              path: ":productId",
              name: "ProductDetail",
              // Vedi nota su CustomerDetail: redirect funzione per interpolare il param.
              redirect: to => ({ name: "ProductCard", params: { productId: to.params.productId } }),
              component: ProductDetail,
              meta: {
                menuSection: "products",
                detail: "productName",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
              children: [
                {
                  path: "card",
                  name: "ProductCard",
                  component: ProductCard,
                  meta: {
                    tabs: {
                      productDetail: "productCard",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "commitments",
                  name: "ProductCommitments",
                  component: ProductCommitments,
                  meta: {
                    tabs: {
                      productDetail: "productCommitments",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "arrivals",
                  name: "ProductArrivals",
                  component: ProductArrivals,
                  meta: {
                    tabs: {
                      productDetail: "productArrivals",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "agencies",
                  name: "ProductAgencies",
                  component: ProductAgencies,
                  meta: {
                    tabs: {
                      productDetail: "productAgencies",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "history",
                  name: "ProductHistory",
                  component: ProductHistory,
                  meta: {
                    tabs: {
                      productDetail: "productHistory",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "availabilities",
                  name: "ProductAvailabilities",
                  component: ProductAvailabilities,
                  meta: {
                    tabs: {
                      productDetail: "productAvailabilities",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "cross-references",
                  name: "ProductCrossReferences",
                  component: ProductCrossReferences,
                  meta: {
                    tabs: {
                      productDetail: "productCrossReferences",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "replacer",
                  name: "ProductReplacer",
                  component: ProductReplacer,
                  meta: {
                    tabs: {
                      productDetail: "productReplacer",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "variant",
                  name: "ProductVariant",
                  component: ProductReplacer,
                  meta: {
                    tabs: {
                      productDetail: "ProductVariant",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "mono",
                  name: "ProductMono",
                  component: ProductReplacer,
                  meta: {
                    tabs: {
                      productDetail: "ProductMono",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
                {
                  path: "mandatory",
                  name: "ProductMandatory",
                  component: ProductReplacer,
                  meta: {
                    tabs: {
                      productDetail: "ProductMandatory",
                    },
                    menuSection: "products",
                    hasChangeCustomer: true,
                    navTitleRoute: "CustomerDetail",
                    hasCustomNavTitle: true,
                    hasCart: true,
                    showCart: () => !!useRootStore().lastCartPath,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/revenue",
          name: "Revenue",
          component: Revenue,
          meta: {
            menuSection: "revenue",
          },
        },
        {
          path: "/commissions",
          name: "Commissions",
          component: Commissions,
          meta: {
            menuSection: "commissions",
          },
        },
        {
          path: "/orders",
          name: "Orders",
          redirect: "/orders/list",
          component: Orders,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            setNavigationTitle(to);
            next();
          },
          meta: {
            menuSection: "insertedOrders",
            hidden: true,
          },
          children: [
            {
              path: "list",
              name: "InsertedOrders",
              component: InsertedDocuments,
              meta: {
                menuSection: "insertedOrders",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId/cart",
              name: "OrdersCart",
              component: Cart,
              meta: {
                menuSection: "insertedOrders",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => true,
              },
            },
            {
              path: ":documentId/analysis",
              name: "OrdersAnalysis",
              component: DocumentAnalysis,
              meta: {
                menuSection: "insertedOrders",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId/margins",
              name: "OrdersDocumentMargins",
              component: DocumentMargins,
              meta: {
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId/details",
              name: "GetOrderDetail",
              component: DocumentDetail,
              meta: {
                hideActionsBar: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
          ],
        },
        {
          path: "/offers",
          name: "Offers",
          redirect: "/offers/list",
          component: Offers,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            setNavigationTitle(to);
            next();
          },
          meta: {
            menuSection: "insertedOffers",
            hidden: true,
          },
          children: [
            {
              path: "list",
              name: "InsertedOffers",
              component: InsertedDocuments,
              meta: {
                menuSection: "insertedOffers",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId",
              name: "OfferConfirmation",
              component: OfferDetail,
              meta: {
                menuSection: "insertedOffers",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
            {
              path: ":documentId/cart",
              name: "OffersCart",
              component: Cart,
              meta: {
                menuSection: "insertedOffers",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => true,
              },
            },
            {
              path: ":documentId/analysis",
              name: "OffersAnalysis",
              component: DocumentAnalysis,
              meta: {
                menuSection: "insertedOffers",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId/margins",
              name: "OffersDocumentMargins",
              component: DocumentMargins,
              meta: {
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId/details",
              name: "GetOfferDetail",
              component: DocumentDetail,
              meta: {
                hideActionsBar: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
          ],
        },
        {
          path: "/bills",
          name: "Bills",
          redirect: "/bills/list",
          component: Bills,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            setNavigationTitle(to);
            next();
          },
          meta: {
            menuSection: "insertedBills",
            hidden: true,
          },
          children: [
            {
              path: "list",
              name: "InsertedBills",
              component: InsertedDocuments,
              meta: {
                menuSection: "insertedBills",
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
            {
              path: ":documentId/cart",
              name: "BillsCart",
              component: Cart,
              meta: {
                menuSection: "insertedBills",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => true,
              },
            },
          ],
        },
        {
          path: "/statistics",
          name: "Statistics",
          component: Statistics,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            if (to.meta.hasCustomNavTitle) {
              useRootStore().setNavigationTitle("");
            }
            next();
          },
          children: [
            {
              path: ":type",
              name: "StatisticsTemplates",
              component: StatisticsTemplates,
              meta: {
                hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                menuSectionDynamic: {
                  routeParam: "type",
                  routeSuffix: "Statistics",
                },
              },
            },
            {
              path: "mix/new",
              name: "StatisticsMixDetailNew",
              component: StatisticsMixDetail,
              meta: {
                menuSection: "mixStatistics",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
            {
              path: "mix/:templateId",
              name: "StatisticsMixDetailEdit",
              component: StatisticsMixDetail,
              meta: {
                menuSection: "mixStatistics",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
            {
              path: ":type/new",
              name: "StatisticsDetailNew",
              component: StatisticsDetail,
              meta: {
                menuSection: "mixStatistics",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                menuSectionDynamic: {
                  routeParam: "type",
                  routeSuffix: "Statistics",
                },
              },
            },
            {
              path: ":type/:templateId",
              name: "StatisticsDetailEdit",
              component: StatisticsDetail,
              meta: {
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                menuSectionDynamic: {
                  routeParam: "type",
                  routeSuffix: "Statistics",
                },
              },
            },
          ],
        },
        {
          path: "/activities",
          name: "Activities",
          redirect: "/activities/list",
          component: Activities,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            if (to.meta.hasCustomNavTitle) {
              useRootStore().setNavigationTitle("");
            }
            next();
          },
          children: [
            {
              path: "list",
              name: "RecommendedActivities",
              component: RecommendedActivities,
              meta: {
                menuSection: "recommendedActivities",
                // hasChangeCustomer: true,
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
              },
            },
          ],
        },
        {
          path: "/tasks",
          name: "Tasks",
          redirect: "/tasks/opened",
          component: Tasks,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            setNavigationTitle(to);
            next();
          },
          children: [
            {
              path: "opened",
              name: "OpenedTasks",
              component: OpenedTasks,
              meta: {
                menuSection: "openedTasks",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: false,
              },
            },
            {
              path: "shared",
              name: "SharedTasks",
              component: SharedTasks,
              meta: {
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: false,
              },
            },
          ],
        },
        {
          path: "/tags",
          name: "Tags",
          redirect: "/tags/management",
          component: Tags,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            if (to.meta.hasCustomNavTitle) {
              useRootStore().setNavigationTitle("");
            }
            next();
          },
          children: [
            {
              path: "management",
              name: "TagsManagement",
              component: TagsManagement,
              meta: {
                menuSection: "tagsManagement",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
          ],
        },
        {
          path: "/calendar",
          name: "Calendar",
          redirect: "/calendar/events",
          component: Calendar,
          beforeEnter: async (to, from, next) => {
            if (!useRootStore().lastCustomer) {
              const [customer] =
                (await useCustomersStore().getLastCustomer()) || [];
              useRootStore().setLastCustomer(customer);
            }
            if (to.meta.hasCustomNavTitle) {
              useRootStore().setNavigationTitle("");
            }
            next();
          },
          children: [
            {
              path: "events",
              name: "CalendarEvents",
              component: CalendarEvents,
              meta: {
                menuSection: "calendarEvents",
                navTitleRoute: "CustomerDetail",
                hasCustomNavTitle: true,
                hasCart: true,
                showCart: () => !!useRootStore().lastCartPath,
              },
            },
          ],
        },
      ],
    },
    {
      path: "/index.html",
      beforeEnter: (to, from, next) => {
        next("/");
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta && (to.meta.menuSection || to.meta.menuSectionDynamic)) {
    if (to.meta.menuSectionDynamic) {
      const { routeParam, routeSuffix } = to.meta.menuSectionDynamic;
      // TODO: ERROR TO CAMELIZESTRING, TO.PARAMS IS EMPTY, FIX THIS!!!
      const sideMenu = useRootStore().sideMenu;
      if (to.params[routeParam]) {
        const routePrefix = utility.camelizeString(to.params[routeParam]);
         
        to.meta.menuSection = `${routePrefix}${routeSuffix}`;
        useRootStore().setSelectedNav(to.meta.menuSection);
      } else {
         
        to.meta.menuSection = sideMenu[0].name;
         
        to.params.type = sideMenu[0].routeParams.type;
        useRootStore().setSelectedNav(to.meta.menuSection);
        const menuItem = baseMenu.find(
          (item) => item.name === to.meta.menuSection
        );
        useRootStore().setSectionCode(menuItem.code);
        const sideMenuType = sideMenu[0].routeParams.type;
        const path = `/${routeSuffix.toLowerCase()}/${sideMenuType}`;
        next(path);
        return;
      }
    } else {
      useRootStore().setSelectedNav(to.meta.menuSection);
    }
    const menuItem = baseMenu.find((item) => item.name === to.meta.menuSection);
    useRootStore().setSectionCode(menuItem.code);
  }
  next();
});

export default router;
